
import { Component, ChangeDetectionStrategy, signal, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { PortalCustomizerComponent } from '../portal-customizer/portal-customizer.component';
import { ClinicSettingsComponent } from '../clinic-settings/clinic-settings.component';
import { FormsModule } from '@angular/forms';
import { PosDeviceManagementComponent } from '../pos-device-management/pos-device-management.component';
import { AuthService } from '../../services/auth.service';

type SettingsView = 'general' | 'clinic_config' | 'pos_devices';

interface SettingsNavItem {
  id: SettingsView;
  labelKey: string;
  icon: string;
  sectionHeader?: string;
}

@Component({
  selector: 'app-settings',
  standalone: true,
  templateUrl: './settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslatePipe,
    PortalCustomizerComponent,
    ClinicSettingsComponent,
    FormsModule,
    PosDeviceManagementComponent
  ],
})
export class SettingsComponent {
  private authService = inject(AuthService);
  
  activeView = signal<SettingsView>('general');

  navItems = computed(() => {
    const store = this.authService.currentStore();
    const businessType = store?.businessType || 'CLINIC';

    const items: SettingsNavItem[] = [
      { id: 'general', labelKey: 'backOffice.settings.general', icon: 'fa-solid fa-sliders', sectionHeader: 'ทั่วไป (General)' }
    ];

    // Only show Clinic Settings if business type is CLINIC
    if (businessType === 'CLINIC') {
      items.push({ id: 'clinic_config', labelKey: 'ตั้งค่าคลินิก (Clinic)', icon: 'fa-solid fa-user-doctor', sectionHeader: 'การแพทย์ (Medical)' });
    }

    items.push({ id: 'pos_devices', labelKey: 'backOffice.settings.posDevicesPage.title', icon: 'fa-solid fa-print', sectionHeader: 'อุปกรณ์ (Hardware)' });

    return items;
  });

  setView(view: SettingsView): void {
    this.activeView.set(view);
  }
}
